module.exports = __webpack_public_path__ + "img/lightpurpleby2.4b9d1bcd.png";